import { ContainerSize } from "../../../../../../../api/types/generated-types";

/** @todo James Clark - Aug 4 - add i18n map for container size */
export const containerSizeList = Object.values(ContainerSize);
